import React, { PureComponent } from 'react';

import BarChart from './BarChart';
import Tooltip from './Tooltip';

class ChartContainer extends PureComponent {
  constructor() {
    super();

    this.state = {
      ttPosition: false,
      ttVisible: false,
      ttData: false,
      displayValue: false,
      subDisplayValue: false
    }

    this.updateState = this.updateState.bind(this);
  }

  updateState(nextState) {
    this.setState(nextState);
  }

  render() {
    const showDisplayValue = this.state.displayValue > 0;
    const showSubDisplayValue = this.state.subDisplayValue > 0;

    return (
      <div className="ifdw-chart--wrapper">
        <div className="ifdw-chart--displays">
          {showDisplayValue && <div className="display">
            <div className="display-number">{this.state.displayValue.toFixed(1).replace('.', ',')}</div>
            <div className="display-text">Prozent der Bevölkerung gehören zur Mittelschicht</div>
          </div>}
          {showSubDisplayValue && <div className="display">
            <div className="display-number sub">{this.state.subDisplayValue.toFixed(1).replace('.', ',')}</div>
            <div className="display-text">Prozent der ausgewählten Teilgruppe gehören zur Mittelschicht</div>
          </div>}
        </div>
        <Tooltip {...this.state}/>
        <BarChart updateState={this.updateState} {...this.props}/>
      </div>
    )
  }
}

export default ChartContainer;



/** WEBPACK FOOTER **
 ** ./src/components/Barchart/index.js
 **/